module.exports = __webpack_public_path__ + "img/error-info.08cb53ec.svg";